import React from 'react';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FullPage, Row } from './Layouts';
import PurpleButton from './PurpleButton';
import Footer from './Footer';

import alyx from '../GlobalErrorHandler/svgs/alyx-standard-popup.svg';
import alyxHandUp from '../GlobalErrorHandler/svgs/alyx-ask-your-teacher-popup.svg';

const Container = styled(Row)`
  width: 670px;
  height: 350px;
  border-radius: 15px;
  background-color: #e7eec5;
`;

const Column = styled(Row)`
  flex-direction: column;
  align-items: flex-start;
`;

const ColumnContainer = styled.div`
  position: relative;
  right: -9px;
`;

const Header = styled.h1`
  width: 366px;
  max-width: 366px;
  font-family: Quicksand;
  font-size: 34px;
  font-weight: bold;
  color: #573215;
  line-height: 39px;
  margin-bottom: 8px;
`;

const Copy = styled.span`
  width: 366px;
  max-width: 366px;
  font-family: Quicksand;
  font-weight: bold;
  font-size: 25px;
  color: #573215;
  line-height: 39px;
`;

const GoBackButton = styled(PurpleButton)`
  margin-top: -40px;
  font-size: 32px;
`;

const Alyx = styled.div`
  position: relative;
  top: -8px;
  left: -20px;
`;

const AlyxHandUp = styled.div`
  position: relative;
  top: -8px;
  left: -15px;
`;

const redirect = async () => {
  window.location.href = '/';
};

const renderAlyx = (handUp) => {
  if (handUp) {
    return (
      <AlyxHandUp>
        <img src={alyxHandUp} alt="Alyx looking informative" />
      </AlyxHandUp>
    );
  }
  return (
    <Alyx>
      <img src={alyx} alt="Alyx looking sly" />
    </Alyx>
  );
};
/*
 * Standard Error message popup with "Go Back" button
 * header - Popup header text
 * message - Popup copy
 * buttonTitle - button title
 * handUp - shows same Alyx we use on Ask your Teacher popup
 * customCallback - callback to use instead of redirect
 * parseMessage - optional message parsing if passing html
 * children - if popup has children, they are used to render header section
 * children may be needed when header is not plain text only but contains links, etc
 */
const StandardPopup = ({
  className,
  header,
  message,
  buttonTitle = 'Go Back',
  customCallback,
  handUp = false,
  showAlyx = true,
  children,
  parseMessage = false,
  actionScope,
}) => (
  <FullPage className={className} data-dd-action-name={actionScope}>
    <Container data-testid="error-modal">
      {showAlyx && renderAlyx(handUp)}
      <ColumnContainer>
        <Column>
          <Header data-testid="error-header">{children || header}</Header>
          <Copy data-testid="error-text">{parseMessage ? parse(message) : message}</Copy>
        </Column>
      </ColumnContainer>
    </Container>
    <GoBackButton
      width="300"
      height="80"
      onClick={customCallback || redirect}
      onTouchEnd={customCallback || redirect}
      data-testid="error-button"
      data-dd-action-name={`${actionScope}:go-back`}
    >
      {buttonTitle}
    </GoBackButton>
    <Footer />
  </FullPage>
);

StandardPopup.propTypes = {
  className: PropTypes.string,
  header: PropTypes.string,
  message: PropTypes.string,
  buttonTitle: PropTypes.string,
  customCallback: PropTypes.func,
  handUp: PropTypes.bool,
  showAlyx: PropTypes.bool,
  parseMessage: PropTypes.bool,
  children: PropTypes.node,
  actionScope: PropTypes.string,
};

StandardPopup.defaultProps = {
  className: '',
  header: '',
  message: '',
  buttonTitle: 'Go Back',
  customCallback: undefined,
  handUp: false,
  showAlyx: true,
  parseMessage: false,
  children: null,
  actionScope: 'error-page',
};
export default StandardPopup;
